import React from 'react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { testimonials } from '../data/content';
import { scrollToCheckout } from '../utils/scroll';
export function Testimonials() {
  return <section className="bg-gradient-to-b from-ink to-wine px-6 py-20" data-id="element-131" data-mp="3fycqdmmec5as">
      <Reveal data-id="element-132" data-mp="3b148zo92o5al">
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-133" data-mp="3azjcvu740eam">
          Mensajes reales del grupo de WhatsApp de Elegida
        </p>
        <h2 className="mt-4 font-serif text-[34px] font-bold leading-tight text-white" data-id="element-134" data-mp="31zw9j2utkyex">Ellas ya lo vivieron.</h2>
      </Reveal>
      <div className="mt-10 space-y-5" data-id="element-135" data-mp="2x09yn02gru9a">
        {testimonials.map(t => <Reveal key={t.label} data-id="element-136" data-mp="2s1qbiwc4wcfc">
            <figure className="rounded-2xl rounded-tl-[4px] border border-gold bg-panel p-6" data-id="element-137" data-mp="2s2rxvwylolcd">
              <span className="inline-block rounded-full bg-gold/15 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-138" data-mp="v9omle2pl5zt">
                {t.label}
              </span>
              {t.image && <img src={t.image} alt="Andry y su pareja besándose en la playa, captura del grupo de WhatsApp" className="mt-5 h-auto w-full rounded-xl" data-id="element-139" data-mp="h55aw37q1xxm" />}
              <blockquote className="mt-5 text-base leading-relaxed text-white" data-id="element-140" data-mp="7a4ukqvc5bjq">{t.text}</blockquote>
              <figcaption className="mt-5 text-xs text-muted/70" data-id="element-141" data-mp="zwfxi86ezojp">{t.signature}</figcaption>
            </figure>
          </Reveal>)}
      </div>
      <div className="mt-10" data-id="element-142" data-mp="14u7omzz8j6mu">
        <CtaButton label="Yo también quiero ser Elegida" onClick={scrollToCheckout} data-id="element-143" data-mp="14xlpu4w5x9sp" />
      </div>
    </section>;
}